import { useState, useEffect } from 'react';
import Papa from 'papaparse';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { includesIgnoreCase } from '../util/modelUtils';
import { getAuthToken } from '../../../util/authToken';
const APP_BASE_URL = process.env.REACT_APP_HOST_URL;

const arraysMatch = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((value, index) => value === arr2[index]);
};


const useModelLogic = (match, baseHeaders) => {
    const [fileHeaders, setFileHeaders] = useState([]);
    const [data, setData] = useState([]);
    const [trainPeriod, setTrainPeriod] = useState([]);
    const [allowedtrainPeriod, setallowedtrainPeriod] = useState([]);
    // const [fileUploadUrl, setFileUploadUrl] = useState('');
    // const [fileBaseUrl, setFileBaseUrl] = useState('');
    const [uploadedFileName, setUploadedFileName] = useState('');
    const [allowTrain, setAllowTrain] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUploadEnabled, setIsUploadEnabled] = useState(false);

    useEffect(() => {
        const storedHeaders = localStorage.getItem(match.params.id);
        setIsUploadEnabled(!!storedHeaders);
    }, [match.params.id]);

    const handleFile = (event) => {

        const uploadUrl = `${APP_BASE_URL}/UploadTrainingDataCSV`;
        // search for last index of / and replace the file name with the name Train File appended with current timestamp
        const uuid = crypto.randomUUID();
        const file_name = 'TrainFile' + new Date().getTime() + '-' + uuid + '.csv';

        const file = event.target.files[0];
        if (!file) {
            // toast.error('Please select a valid file');
            // setAllowTrain(false);
            return;
        }

        setUploadedFileName(file_name);
        Papa.parse(file, {
            complete: (result) => {
                const rows = result.data;
                setFileHeaders(rows[0]);
                setData(rows.slice(1));

                const storedHeaders = JSON.parse(localStorage.getItem(match.params.id));
                if (storedHeaders && !arraysMatch(storedHeaders, rows[0])) {
                    toast.error('Uploaded file headers do not match the expected headers');
                    setAllowTrain(false);
                    return;
                }

                if (!includesIgnoreCase(rows[0], 'subject') || !includesIgnoreCase(rows[0], 'timestamp') || !includesIgnoreCase(rows[0], 'MeasuredCorrosionRate')) {
                    toast.error('File is missing required columns');
                    setAllowTrain(false);
                    return;
                }

                const timestampIndex = rows[0].indexOf('timestamp');
                const timestamps = rows.slice(1).map(row => new Date(row[timestampIndex])).filter(date => !isNaN(date));
                if (timestamps.length > 0) {
                    const earliestDate = timestamps.reduce((min, curr) => curr < min ? curr : min, timestamps[0]);
                    const latestDate = timestamps.reduce((max, curr) => curr > max ? curr : max, timestamps[0]);
                    setallowedtrainPeriod([dayjs(earliestDate), dayjs(latestDate)]);
                    setTrainPeriod([dayjs(earliestDate), dayjs(latestDate)]);
                } else {
                    toast.error('No valid timestamps found in the file');
                    setAllowTrain(false);
                    return;
                }

                setIsLoading(true);
                const formData = new FormData();
                formData.append('file', file, file_name);

                fetch(uploadUrl, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        Accept: "application/json",
                        "Authorization": `Bearer ${getAuthToken()}`
                    },
                }).then(() => {
                    toast.success('File uploaded successfully');
                    setAllowTrain(true);
                }).catch((error) => {
                    console.error(error);
                    toast.error('Error uploading file');
                    setAllowTrain(false);
                }).finally(() => {
                    setIsLoading(false);
                });
            },
            header: false,
        });
    };

    return {
        fileHeaders,
        data,
        trainPeriod,
        allowedtrainPeriod,
        uploadedFileName,
        allowTrain,
        isLoading,
        isUploadEnabled,
        setIsUploadEnabled,
        setTrainPeriod,
        handleFile,
    };
};

export default useModelLogic;